import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index";
import moment from 'moment-timezone';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ActionButton from "../common/button/actionbutton.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import { GlobalHelper } from '../indexImports';
import { ONBOARDING_STEP } from './Steps';
import './welcome.scss';
class StripeOnboardingSetup extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            quote: true,
            invoice: true,
            payment: true,
            onStepCompleted: this.props.onStepCompleted || function () { },
        }
        this.submit = this.submit.bind(this)
    }

    componentDidMount() {
        if (this.props.continue) {
            this.state.onStepCompleted({})
        }
        window.scrollTo(0, 0)
    }

    submit() {
        if (!this.state.invoice) {
            AppContext.getApiClient().patch('/accounts/account-details', {
                timeZone: moment.tz.guess(),
                features: [
                    {
                        featureKey: 'invoice',
                        enabled: false,
                    }
                ],
            }).then(() => { })
        }
        if (!this.state.quote && this.state.invoice) {
            const userId = AppContext.getUserLoggedIn().id
            AppContext.getApiClient().patch('/users/' + userId + '/preferences', {
                dashboardType: 'invoice',
                contactTab: 'invoices'
            }).then(_ => { })
        }
        if (this.state.payment) {
            // SECURITY FIX: Backend injects test keys (Bugcrowd #4cefa42c)
            AppContext.getApiClient().post('/integration-configurations', {
                configuration: {},
                integrationKey: "stripe"
            }).then(_ => { })
        }

        this.state.onStepCompleted({})
    }

    render() {
        const stripeUrl = AppContext.getOptions().apiUrl + '/openid/connect/stripe/' +
            AppContext.getUserLoggedIn().id + `?r=/welcome/${ONBOARDING_STEP.ONLINE_PAYMENT_SETUP_STEP}%3Fcontinue=true`

        return (
            <div className="row py-0 justify-content-center pb-5">
                {this.state.modal}
                {this.state.redirect}
                <div className={"col-12 mb-3"}>
                    <div className="row py-0 justify-content-center">
                        <div className="col-lg-6 col-md-8 col-12">
                            <h1 className="text-center custom-lead text-custom-primary mb-0">
                                <FormattedMessage
                                    id="welcome.step_2.payment_setup"
                                    defaultMessage="Payment setup"
                                />
                            </h1>
                        </div>
                    </div>
                </div>
                <div className={'col-12'}>
                    <div className={'row justify-content-center'}>
                        <div className={'col-lg-5 col-md-8 col-12'}>
                            <div className={'row justify-content-center'}>
                                <div className="col-12 ui-module text-center pt-0" style={{ paddingLeft: '0.9rem', paddingRight: '0.9rem' }}>
                                    <div className="row pb-2 pt-3 mb-3 bg-light border rounded-top">
                                        <div className="col-12 text-center">
                                            <h5 className="col-12 align-items-center justify-content-center d-flex"
                                                style={{ borderBottom: 'none', marginBottom: '0', paddingBottom: '0' }}>
                                                <Icon value={'award'} className={'mr-3'} size={'30'} />
                                                <FormattedMessage
                                                    id="welcome.step_2.recommended"
                                                    defaultMessage="Recommended"
                                                />
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <label htmlFor='connectStripe' className={'pl-2 h6 mb-3'}>
                                            <FormattedMessage
                                                id="welcome.step_2.stripe_connect"
                                                defaultMessage="Connect your Stripe account now to process your payments."
                                            />
                                        </label>
                                        <div className={'px-2'}>
                                            {GlobalHelper.InIFrame() ?
                                                <a href={'#'} className="mb-2" onClick={() => {return window.Intercom('showArticle', 4262670)}}>
                                                    <img src={'/images/stripe_connect_btn_en.png'} height={'40px'} />
                                                </a> :
                                                <a href={stripeUrl} className="mb-2">
                                                    <img src={'/images/stripe_connect_btn_en.png'} height={'40px'} />
                                                </a>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 ui-module text-center mb-1">
                                    <div className="text-center">
                                        <label htmlFor='testStripe' className={'pl-2 h6 mb-3'}>
                                            <FormattedMessage
                                                id="welcome.step_2.stripe_connect_test_account"
                                                defaultMessage="Or you may use our Stripe test account and setup yours later."
                                            />
                                        </label>
                                        <div className={'px-2'}>
                                            <ActionButton className={"btn btn-md btn-primary"} onClick={this.submit}>
                                                <Icon value={'credit-card'} className={'mr-2'} />
                                                <FormattedMessage
                                                    id="welcome.submit_payment_setup"
                                                    defaultMessage="Use Stripe test account"
                                                />
                                            </ActionButton>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 text-center px-0">
                                    <div className="text-right">
                                        <ActionButton className={"btn btn-sm btn-link px-0"} onClick={() => {
                                            this.state.payment = false
                                            this.submit()
                                        }}>
                                            <Icon value={'caret-right'} />
                                            <FormattedMessage
                                                id="welcome.skip_payment_setup"
                                                defaultMessage="Skip to the next step"
                                            />
                                        </ActionButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(StripeOnboardingSetup)





// WEBPACK FOOTER //
// ./src/onboarding/StripeOnboardingSetup.jsx